import { Route } from "react-router-dom";
import { PageErrorBoundaryLocal } from "@/components/PageErrorBoundaryLocal";
import { SoulBoundaryWithQuery } from "@/components/SoulBoundaryWithQuery";
import { ROUTES } from "@/constants/routes";
import { resilientLazy } from "@/lib/resilientImport";
import { LegacyRedirect } from "@/routes/LegacyRedirect";

const JornadaFamilia = resilientLazy(() => import("@/pages/JornadaFamilia"), "JornadaFamilia");
const MinhasAulas = resilientLazy(() => import("@/pages/MinhasAulas"), "MinhasAulas");
const BookingCalendar = resilientLazy(() => import("@/pages/BookingCalendar"), "BookingCalendar");
const MeusFavoritos = resilientLazy(() => import("@/pages/MeusFavoritos"), "MeusFavoritos");
const MaterialsFamilia = resilientLazy(() => import("@/pages/MaterialsFamilia"), "MaterialsFamilia");
const RecordingsFamilia = resilientLazy(() => import("@/pages/RecordingsFamilia"), "RecordingsFamilia");
const PagamentoSucesso = resilientLazy(() => import("@/pages/PagamentoSucesso"), "PagamentoSucesso");
const PagamentoCancelado = resilientLazy(() => import("@/pages/PagamentoCancelado"), "PagamentoCancelado");
const Mensagens = resilientLazy(() => import("@/pages/Mensagens"), "Mensagens");
const CalendarioPage = resilientLazy(() => import("@/pages/CalendarioPage"), "CalendarioPage");
const ExpressCheckout = resilientLazy(() => import("@/pages/ExpressCheckout"), "ExpressCheckout");
const PrivacidadeConta = resilientLazy(() => import("@/pages/PrivacidadeConta"), "PrivacidadeConta");
const PreferenciasLembretes = resilientLazy(() => import("@/pages/PreferenciasLembretes"), "PreferenciasLembretes");

export const FamilyRoutes = () => (
  <>
    {/* Dashboard principal usa SoulBoundaryWithQuery para reset real de queries */}
    <Route 
      path="/minha-jornada-familia" 
      element={
        <SoulBoundaryWithQuery 
          fallbackTitle="Oops! Tivemos um tropeço"
          fallbackMessage="Algo não saiu como esperado na sua jornada. Vamos tentar de novo?"
        >
          <JornadaFamilia />
        </SoulBoundaryWithQuery>
      } 
    />
    <Route 
      path={ROUTES.MY_CLASSES_CALENDAR} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar calendário de aulas.">
          <MinhasAulas />
        </PageErrorBoundaryLocal>
      } 
    />
    {/* /minha-jornada (path legado, agora exclusivo da família) → dashboard da família.
        Teacher tem rota dedicada em /historico-de-encontros (ROUTES.CLASS_HISTORY).
        ROUTES.MY_EXPERIENCES === "/minhas-experiencias" — uma única entrada cobre ambos. */}
    <Route path="/minha-jornada" element={<LegacyRedirect to="/minha-jornada-familia" />} />
    <Route path="/jornada-familia" element={<LegacyRedirect to="/minha-jornada-familia" />} />
    <Route path={ROUTES.MY_EXPERIENCES} element={<LegacyRedirect to="/minha-jornada-familia" />} />
    <Route 
      path={ROUTES.MY_FAVORITES} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar favoritos.">
          <MeusFavoritos />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path="/agendar/:teacherId" 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar agendamento.">
          <BookingCalendar />
        </PageErrorBoundaryLocal>
      } 
    />

    <Route
      path={ROUTES.PAYMENT_SUCCESS}
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar confirmação de pagamento.">
          <PagamentoSucesso />
        </PageErrorBoundaryLocal>
      }
    />
    <Route
      path={ROUTES.PAYMENT_CANCEL}
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar cancelamento de pagamento.">
          <PagamentoCancelado />
        </PageErrorBoundaryLocal>
      }
    />
    <Route 
      path="/materiais-familia" 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar materiais.">
          <MaterialsFamilia />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path="/gravacoes-familia" 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gravações.">
          <RecordingsFamilia />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.MESSAGES} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar mensagens.">
          <Mensagens />
        </PageErrorBoundaryLocal>
      } 
    />
    
    {/* Calendário dedicado */}
    <Route
      path={ROUTES.CALENDAR}
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar o calendário.">
          <CalendarioPage />
        </PageErrorBoundaryLocal>
      }
    />

    {/* Express Checkout */}
    <Route
      path="/checkout/:classId"
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar checkout.">
          <ExpressCheckout />
        </PageErrorBoundaryLocal>
      }
    />

    {/* LGPD self-service */}
    <Route
      path={ROUTES.ACCOUNT_PRIVACY}
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar privacidade da conta.">
          <PrivacidadeConta />
        </PageErrorBoundaryLocal>
      }
    />

    {/* Preferências de lembretes (família/educador) */}
    <Route
      path={ROUTES.ACCOUNT_REMINDERS}
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar preferências de lembretes.">
          <PreferenciasLembretes />
        </PageErrorBoundaryLocal>
      }
    />

    {/* NOTA: ROUTES.JOURNEY_FAMILY === "/minha-jornada-familia" e já está registrado
        acima como rota canônica (linha 25). Não recriar aqui — seria self-loop. */}
  </>
);
